import { useMentionCandidates } from '@modules/conversations/hooks/use-mention-candidates';
import { mentionsToText } from '@modules/conversations/utils/mention';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useMentionText() {
  const { labels } = useMentionCandidates();
  const { t } = useTranslation();
  const removedLabel = capitalizeFirst(t('removed_member'));

  return useCallback(
    (body: string | null | undefined) =>
      body ? mentionsToText(body, (target) => labels.get(target)?.name, removedLabel) : '',
    [labels, removedLabel]
  );
}
